import { prompt } from '../../../lib/bootbox'

export async function getSleepTimeout(postpone: number): Promise<number | undefined> {
  const promptTimeout = await prompt({
    title: 'How many seconds would you like me to sleep?',
    value: postpone
  })

  if (!promptTimeout) {
    return
  }

  const timeout = parseInt(promptTimeout, 10)
  if (isNaN(timeout)) {
    return await getSleepTimeout(timeout)
  }

  return timeout
}
